import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { BackofficeContext } from "@/v2/framework/context/types";
import { createAddDialog } from "./add";
import { createDeleteDialog } from "./delete";
import { createEditDialog } from "./edit";

export function createDialogs(options: {
  ctx: BackofficeContext;
  outcomesApi: OutcomesApi;
  marketsApi: MarketsApi;
}) {
  return {
    add: createAddDialog(options),
    delete: createDeleteDialog(options),
    edit: createEditDialog(options),
  };
}
